/**
 * Leave-by reminders, PWA minimum (docs/10 M13): a local notification shown
 * by the service worker at leave-by while the app is open (foreground or a
 * background tab). No server push in v1 — there is no sender, and docs/08
 * requires push subscriptions to be revalidated on open anyway.
 *
 * One timer per plan, replaced on re-schedule; the tag de-duplicates on the
 * notification side if the page fires twice.
 */
const timers = new Map<string, ReturnType<typeof setTimeout>>();

export async function scheduleReminder(plan: {
  id: string; title: string; staging_label: string; leave_by: string | null;
}): Promise<boolean> {
  if (!plan.leave_by || !('Notification' in window) || !('serviceWorker' in navigator)) return false;
  let permission = Notification.permission;
  if (permission === 'default') permission = await Notification.requestPermission();
  if (permission !== 'granted') return false;

  const delay = new Date(plan.leave_by).getTime() - Date.now();
  const existing = timers.get(plan.id);
  if (existing) clearTimeout(existing);
  if (delay <= 0) return true;   // already due: the card says Leave now

  timers.set(plan.id, setTimeout(async () => {
    timers.delete(plan.id);
    try {
      const reg = await navigator.serviceWorker.ready;
      await reg.showNotification(`Leave now for ${plan.title}`, {
        body: `Pickup: ${plan.staging_label}`,
        tag: `surge-leave-${plan.id}`,
        icon: '/icon.svg',
        requireInteraction: true,
      });
    } catch { /* notification API unavailable: the card still updates */ }
  }, delay));
  return true;
}

export function cancelReminder(id: string): void {
  const t = timers.get(id);
  if (t) { clearTimeout(t); timers.delete(id); }
}
